'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Simplified interface to react-select with styling
 */
var Select = function Select(props) {
    var theme = props.theme,
        selectProps = (0, _objectWithoutProperties3.default)(props, ['theme']);

    return _react2.default.createElement(_reactSelect2.default, (0, _extends3.default)({}, selectProps, {
        clearable: false,
        searchable: false,
        className: theme && theme.select
    }));
};

Select.displayName = 'Select';

exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/lib/Select/index.js
// module id = 859
// module chunks = 4 5 8 9 14